import {NgModule} from '@angular/core';
import {DoughnutComponent} from './doughnut.component';

@NgModule({
    exports: [DoughnutComponent],
    declarations: [DoughnutComponent]
})
export class DoughnutModule {
}